import { Injectable } from '@angular/core';
import { ApiService } from '@edgvr-front/api/data-access';
import {
  BinaryCreateCmd,
  BinaryEntity,
  BinaryEntityRaw,
} from '@edgvr-front/binaries/domain';
import { map } from 'rxjs';

@Injectable()
export class BinariesService {
  constructor(private readonly apiService: ApiService) {}

  binaryCreate(binaryCreateCmd: BinaryCreateCmd) {
    const formData = new FormData();

    formData.set('instance', binaryCreateCmd.value.instance);
    formData.set('version', binaryCreateCmd.value.version);
    formData.set('binary', binaryCreateCmd.value.file);

    return this.apiService
      .post<BinaryEntityRaw>('binaries', formData)
      .pipe(map((_) => new BinaryEntity(_)));
  }

  listLatest() {
    return this.apiService
      .get<BinaryEntityRaw[]>('binaries/latest')
      .pipe(map((_) => _.map((_) => new BinaryEntity(_))));
  }
}
